import { InjectionToken } from '@angular/core';

export const AppName = new InjectionToken<'PATHWAY' | 'RELAY' | 'NUCLEUS'>('App Name');
